import { render, staticRenderFns } from "./Com_SupplyChain-echart.vue?vue&type=template&id=96eb2c56&scoped=true&"
import script from "./Com_SupplyChain-echart.vue?vue&type=script&lang=js&"
export * from "./Com_SupplyChain-echart.vue?vue&type=script&lang=js&"
import style0 from "./Com_SupplyChain-echart.vue?vue&type=style&index=0&id=96eb2c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eb2c56",
  null
  
)

export default component.exports